import React, { useState } from 'react';
import './css/GroupDiscussion.css'; // Dedicated page styles

// Reusing your standalone, modular layout components
import Navbar from './components/Navbar';
import Newsletter from './components/NewsLetter';
import Footer from './components/Footer';

// Reusing your global hero and banner background assets
import gdHeroBg from '../images/quiz_banner.png';
import feedBgImage from '../images/Banner3.png'; // Background image for the section
import DownloadAppForum from './components/DownloadAppForum';

function Quiz() {
    // State to control the login/register popup modal (from original code)
    const [showLoginModal, setShowLoginModal] = useState(false);

    // Quiz Play Modal States
    const [activeQuiz, setActiveQuiz] = useState(null);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [selectedOption, setSelectedOption] = useState(null);
    const [score, setScore] = useState(0);
    const [quizCompleted, setQuizCompleted] = useState(false);

    // Four trending/popular quiz topics with questions
    const quizzesData = [
        {
            id: 1,
            title: "Quantitative Aptitude Mastery",
            category: "Trending",
            difficulty: "Intermediate",
            description: "Sharpen your mathematical reasoning with high-yield quantitative questions designed for competitive exams.",
            bgColor: "rgba(255, 255, 255, 0.95)",
            borderColor: "#165682",
            questions: [
                {
                    question: "What is 15% of 200?",
                    options: ["20", "25", "30", "35"],
                    answer: "30"
                },
                {
                    question: "If a train travels 60 km in 45 minutes, what is its speed in km/h?",
                    options: ["70 km/h", "80 km/h", "90 km/h", "100 km/h"],
                    answer: "80 km/h"
                },
                {
                    question: "Find the next number in the series: 2, 6, 12, 20, 30, ?",
                    options: ["40", "42", "44", "48"],
                    answer: "42"
                }
            ]
        },
        {
            id: 2,
            title: "Logical Reasoning & Analytical Skills",
            category: "Most Popular",
            difficulty: "Advanced",
            description: "Test your deductive reasoning, pattern recognition, and problem-solving framework under timed pressure.",
            bgColor: "rgba(255, 255, 255, 0.95)",
            borderColor: "#3F9A96",
            questions: [
                {
                    question: "If CAT is coded as 31220, how is DOG coded?",
                    options: ["4157", "4158", "3147", "5167"],
                    answer: "4157"
                },
                {
                    question: "Which word does not belong with the others? Tulip, Rose, Bud, Daisy",
                    options: ["Tulip", "Rose", "Bud", "Daisy"],
                    answer: "Bud"
                },
                {
                    question: "Looking at a portrait, a man said, 'That man's father is my father's son.' Who is it?",
                    options: ["His Brother", "His Son", "Himself", "His Nephew"],
                    answer: "Himself"
                }
            ]
        },
        {
            id: 3,
            title: "General Science & Technology",
            category: "Trending",
            difficulty: "Beginner",
            description: "Explore core concepts spanning modern physics, computer science innovations, and biological systems.",
            bgColor: "rgba(255, 255, 255, 0.95)",
            borderColor: "#D59B0F",
            questions: [
                {
                    question: "Which gas is most abundant in the Earth's atmosphere?",
                    options: ["Oxygen", "Hydrogen", "Nitrogen", "Carbon Dioxide"],
                    answer: "Nitrogen"
                },
                {
                    question: "What does CPU stand for?",
                    options: ["Central Process Unit", "Central Processing Unit", "Computer Personal Unit", "Central Processor Utility"],
                    answer: "Central Processing Unit"
                },
                {
                    question: "What is the chemical symbol for Gold?",
                    options: ["Ag", "Fe", "Au", "Cu"],
                    answer: "Au"
                }
            ]
        },
        {
            id: 4,
            title: "English Comprehension & Grammar",
            category: "Recommended",
            difficulty: "Intermediate",
            description: "Evaluate your vocabulary precision, sentence structure correction, and contextual word usage.",
            bgColor: "rgba(255, 255, 255, 0.95)",
            borderColor: "#8E44AD",
            questions: [
                {
                    question: "Choose the correct synonym for 'Benevolent':",
                    options: ["Hostile", "Kind", "Greedy", "Indifferent"],
                    answer: "Kind"
                },
                {
                    question: "Identify the antonym of 'Abundant':",
                    options: ["Scarcity", "Plentiful", "Ample", "Generous"],
                    answer: "Scarcity"
                },
                {
                    question: "Which sentence is grammatically correct?",
                    options: [
                        "She don't like coffee.",
                        "They goes to the market.",
                        "He has completed his assignment.",
                        "I has been waiting here."
                    ],
                    answer: "He has completed his assignment."
                }
            ]
        }
    ];

    const handleStartQuiz = (quiz) => {
        setActiveQuiz(quiz);
        setCurrentQuestionIndex(0);
        setSelectedOption(null);
        setScore(0);
        setQuizCompleted(false);
    };

    const handleOptionSelect = (option) => {
        setSelectedOption(option);
    };

    const handleNextQuestion = () => {
        const currentQ = activeQuiz.questions[currentQuestionIndex];
        if (selectedOption === currentQ.answer) {
            setScore(score + 1);
        }

        if (currentQuestionIndex + 1 < activeQuiz.questions.length) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setSelectedOption(null);
        } else {
            setQuizCompleted(true);
        }
    };

    return (
        <div className="gd-page-wrapper">

            {/* 1. Header Hero Section with integrated clean Navbar */}
            <section
                className="gd-hero-section"
                style={{ backgroundImage: `url(${gdHeroBg})` }}
            >
                <Navbar />
            </section>

            {/* 2. Quiz Section with Background Image & Topics Grid */}
            <section
                className="gd-feed-section py-5"
                style={{
                    backgroundImage: `url(${feedBgImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'repeat'
                }}
            >
                <div className="container">
                    <div className="row justify-content-center text-center mb-4">
                        <div className="col-lg-8">
                            <span className="ufc-grid-mini-tag">INTERACTIVE ASSESSMENTS</span>
                            <h2 className="ufc-grid-heading" style={{ color: '#207AB4' }}>
                                Trending Quiz Topics & Live Challenges
                            </h2>
                            <div className="ufc-zigzag-border mx-auto mt-2"></div>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            {/* Quiz Cards Grid */}
                            <div className="row">
                                {quizzesData.map((quiz) => (
                                    <div key={quiz.id} className="col-md-6 mb-4">
                                        <div
                                            className="gd-post-card p-4 shadow-sm h-d-flex flex-column justify-content-between"
                                            style={{
                                                backgroundColor: quiz.bgColor,
                                                border: `2px solid ${quiz.borderColor}`,
                                                borderRadius: '16px',
                                                backdropFilter: 'blur(10px)',
                                                WebkitBackdropFilter: 'blur(10px)',
                                                height: '100%'
                                            }}
                                        >
                                            <div>
                                                <div className="d-flex justify-content-between align-items-center mb-3">
                                                    <span
                                                        className="badge rounded-pill px-3 py-2 text-white fw-bold"
                                                        style={{ backgroundColor: quiz.borderColor, fontSize: '12px' }}
                                                    >
                                                        {quiz.category}
                                                    </span>
                                                    <span className="text-muted fw-semibold" style={{ fontSize: '13px' }}>
                                                        Difficulty: {quiz.difficulty}
                                                    </span>
                                                </div>

                                                <h3 className="h5 fw-bold mb-2" style={{ color: '#207AB4' }}>
                                                    {quiz.title}
                                                </h3>

                                                <p className="text-secondary mb-4" style={{ fontSize: '14.5px', lineHeight: '1.5' }}>
                                                    {quiz.description}
                                                </p>
                                            </div>

                                            <div className="pt-3 border-top d-flex justify-content-between align-items-center">
                                                <span className="text-muted" style={{ fontSize: '13.5px' }}>
                                                    {quiz.questions.length} Questions
                                                </span>
                                                <button
                                                    onClick={() => handleStartQuiz(quiz)}
                                                    className="btn text-white px-4 py-2 rounded-pill fw-bold border-0 shadow-sm"
                                                    style={{ backgroundColor: quiz.borderColor, fontSize: '14px' }}
                                                >
                                                    Play Quiz
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* Centered Explore More Button */}
                            <div className="text-center mt-4">
                                <button
                                    onClick={() => window.open('https://forum.crestest.com/register', '_blank', 'noopener,noreferrer')}
                                    className="btn text-white px-5 py-3 rounded-pill fw-bold shadow-lg"
                                    style={{
                                        backgroundColor: '#207AB4',
                                        fontSize: '15px',
                                        letterSpacing: '0.5px'
                                    }}
                                >
                                      Join Forum & Explore More &rarr;
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Interactive Play Quiz Modal */}
            {activeQuiz && (
                <div
                    className="gd-modal-backdrop position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999 }}
                >
                    <div
                        className="bg-white p-4 rounded-4 shadow position-relative mx-3"
                        style={{ maxWidth: '500px', width: '100%' }}
                    >
                        {!quizCompleted ? (
                            <div>
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <span className="badge bg-light text-dark fw-bold border" style={{ fontSize: '12px' }}>
                                        Question {currentQuestionIndex + 1} of {activeQuiz.questions.length}
                                    </span>
                                    <span className="fw-bold" style={{ color: '#207AB4', fontSize: '13.5px' }}>
                                        Score: {score}
                                    </span>
                                </div>

                                <h4 className="fw-bold mb-3" style={{ color: '#207AB4', fontSize: '18px' }}>
                                    {activeQuiz.title}
                                </h4>

                                <p className="fw-semibold text-dark mb-4" style={{ fontSize: '15px' }}>
                                    {activeQuiz.questions[currentQuestionIndex].question}
                                </p>

                                <div className="d-flex flex-column gap-2 mb-4">
                                    {activeQuiz.questions[currentQuestionIndex].options.map((option, idx) => (
                                        <button
                                            key={idx}
                                            onClick={() => handleOptionSelect(option)}
                                            className={`btn text-start p-3 rounded-3 fw-semibold border ${
                                                selectedOption === option ? 'text-white' : 'bg-light text-dark border-light'
                                            }`}
                                            style={{
                                                backgroundColor: selectedOption === option ? '#207AB4' : '#f8f9fa',
                                                borderColor: selectedOption === option ? '#207AB4' : '#dee2e6',
                                                fontSize: '14px'
                                            }}
                                        >
                                            {option}
                                        </button>
                                    ))}
                                </div>

                                <div className="d-flex justify-content-end">
                                    <button
                                        onClick={handleNextQuestion}
                                        disabled={!selectedOption}
                                        className="btn text-white px-4 py-2 rounded-pill fw-bold border-0"
                                        style={{
                                            backgroundColor: selectedOption ? '#207AB4' : '#cccccc',
                                            fontSize: '14px',
                                            cursor: selectedOption ? 'pointer' : 'not-allowed'
                                        }}
                                    >
                                        {currentQuestionIndex + 1 === activeQuiz.questions.length ? 'Finish Quiz' : 'Next Question'}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="text-center py-3">
                                <h3 className="fw-bold mb-3" style={{ color: '#207AB4' }}>
                                    Quiz Completed! 🎉
                                </h3>
                                <p className="text-secondary mb-3" style={{ fontSize: '15px' }}>
                                    You scored <strong className="text-dark">{score}</strong> out of <strong className="text-dark">{activeQuiz.questions.length}</strong>.
                                </p>
                                <div className="d-flex justify-content-center gap-2">
                                    <button
                                        onClick={() => handleStartQuiz(activeQuiz)}
                                        className="btn text-white px-4 py-2 rounded-pill fw-bold border-0"
                                        style={{ backgroundColor: '#207AB4', fontSize: '14px' }}
                                    >
                                        Try Again
                                    </button>
                                    <button
                                        onClick={() => setActiveQuiz(null)}
                                        className="btn px-4 py-2 rounded-pill fw-bold border bg-light text-dark"
                                        style={{ fontSize: '14px' }}
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* Close Modal Button */}
                        <button
                            onClick={() => setActiveQuiz(null)}
                            className="position-absolute top-0 end-0 m-3 border-0 bg-transparent text-muted fw-bold fs-5"
                            style={{ cursor: 'pointer' }}
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}

            {/* Login / Register Popup Modal */}
            {showLoginModal && (
                <div
                    className="gd-modal-backdrop position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center"
                    style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999 }}
                >
                    <div
                        className="gd-modal-content bg-white p-4 rounded-4 shadow text-center position-relative mx-3"
                        style={{ maxWidth: '400px', width: '100%' }}
                    >
                        <h4 className="fw-bold mb-3" style={{ color: '#207AB4' }}>
                            Authentication Required
                        </h4>
                        <p className="text-secondary mb-4" style={{ fontSize: '14px' }}>
                            You need to login or register first to comment or make a post in the scholars' discussion feed.
                        </p>
                        <div className="d-flex gap-2 justify-content-center">
                            <button
                                onClick={() => window.open('https://forum.crestest.com/login', '_blank', 'noopener,noreferrer')}
                                className="btn text-white px-4 py-2 rounded-pill fw-bold border-0"
                                style={{ backgroundColor: '#207AB4', fontSize: '14px' }}
                            >
                                Login
                            </button>
                            <button
                                onClick={() => window.open('https://forum.crestest.com/register', '_blank', 'noopener,noreferrer')}
                                className="btn px-4 py-2 rounded-pill fw-bold border"
                                style={{ backgroundColor: '#57BDB9', color: '#ffffff', borderColor: '#3F9A96', fontSize: '14px' }}
                            >
                                Register
                            </button>
                        </div>
                        <button
                            onClick={() => setShowLoginModal(false)}
                            className="position-absolute top-0 end-0 m-3 border-0 bg-transparent text-muted fw-bold fs-5"
                            style={{ cursor: 'pointer' }}
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}

            {/* Download App Section */}
            <DownloadAppForum />

            {/* 3. Reusable Global Bottom Components */}
            <Newsletter />
            <Footer />

        </div>
    );
}

export default Quiz;